import axiosInstance from './index';
/**
 * 생성한 axiosInstance의 GET 요청 함수
 *
 * @param url: API 주소. baseUrl이 apis.tving.com로 설정되어있으나 웬만하면 항상 FULL URL을 사용하기로 하자!
 * @param requestConfig: header, timeout 등 다양한 설정을 함수 사용자에게 전가
 */
var httpGet = function (url, requestConfig) {
    return axiosInstance
        .get(url, requestConfig)
        .then(function (response) {
        var data = response.data;
        return data;
    })
        .catch(function (error) {
        return Promise.reject(error);
    });
};
export default httpGet;
